(() => {
    const otpEl = document.querySelectorAll('#enterOtpDetails .wu-input')
    const OtpErrorField = document.getElementById('OtpErrorField')
    console.log("otp validation")
    for(let i=0;i<otpEl.length;i++) {
        otpEl[i].addEventListener('input', (e) => {
            let value = e.target.value
            if(value) value = parseInt(value)
            if(value && value > 9) {
                e.target.value = value%10 
            }
            if (i < otpEl.length - 1) {
                otpEl[i+1].focus()
            }

        })
        
        const removeBdrs = () => {
            otpEl.forEach((e) => {
                e.classList.remove("bdr-clr-rt-error", "bdr-clr-tp-error", "bdr-clr-bm-error","bdr-clr-lt-error")
            })
        }

        otpEl[i].addEventListener('keydown', (e) => {
            if(e.target.classList.contains("bdr-clr-rt-error")) {
                removeBdrs()
                OtpErrorField?.classList.add('d-none');
            }
            // e.target.classList.remove("bdr-clr-rt-error", "bdr-clr-tp-error", "bdr-clr-bm-error","bdr-clr-lt-error")
            if (e.key === "Backspace" || e.code === "Backspace") {
                if(!e.target.value && i > 0) {
                    otpEl[i-1].value = ''
                    otpEl[i-1].focus()
                }
            }
        })
    }
    
})()